<template>
  <router-view></router-view>
</template>

<script>
import './components/League/store';
export default {
  name: 'league'
};
</script>

<style lang="less" scoped></style>
